import Fetcher from "../utils/fetcher";

export class WebchatAuthService {
    async auth(code: string, state: string, redirectUri: string, service: string) {
        return await Fetcher<any>('/webchat/api/v2/client/authentications/alfa_id?code=' + code + '&redirect_uri=' + redirectUri + '&service=' + service + '&source=web' + '&state=' + state)
            .get()
            .jsonWithoutThrow();
    }
}
